import { TextField, InputAdornment, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const InputField = (props) => {
    const handleChange = (event) => {
        props.setValue(event.target.value);
        props.validate()
    };
    const handleClear = (event) => {
        props.setValue("");
        props.validate()
    };
    return (
        <>
            <div>
                <TextField
                    required
                    id="standard-text"
                    label={`${props.field}`}
                    value={props.value}
                    onChange={handleChange}
                    maxLength="50"
                    variant="standard"
                    fullWidth={props.fullWidth}
                    type={props.type}
                    error={props.error ? true : false}
                    helperText={props.error}
                    onKeyDown={props.onKeyDown}
                    InputProps={{
                        style: { width: props.width },
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="clear text"
                                    onClick={handleClear}
                                    edge="end"
                                >
                                    {" "}
                                    {props.value ? (
                                        <CancelIcon />
                                    ) : (
                                        <CancelIcon color="disabled" sx={{ opacity: 0 }} />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
        </>
    );
};
export default InputField;